// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { productDetailsImageCarouselStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsImageCarousel";
import { color, hideElementOnPrint, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

export const overrideStyles = (isSelected?: boolean) => ({
    css: css`
        border-radius: 2px;
        width: 52px;
        height: 52px;
        padding: 0;
        img {
            width: 52px;
            height: 52px;
            padding: 0;
            object-fit: contain;
        }
        border: 1px solid ${isSelected ? color("common.black") : "transparent"};
    `,
});

productDetailsImageCarouselStyles.imageCarousel = {
    carouselWrapper: {
        css: css`
            ${hideElementOnPrint}
        `,
    },
    carousel: {
        container: {
            css: css`
                margin-top: 16px;
                .swiper-initialized {
                    margin: 0;
                }
            `,
        },
    },
    image: overrideStyles(),
    selectedImage: overrideStyles(true),
    carouselSlideInner: {
        css: css`
            padding: 0;
        `,
    },
} as any;
